export default {
  data: [],
  seriesData: [],
  videos: [],
  currentSeriesVideos: [],
  isLoading: false,
  showTeachers: false,
  teacherSort: [],
};
